interface HpBarProps {
  current: number;
  max: number;
  width?: number;
}

function toSafePercent(current: number, max: number) {
  if (!Number.isFinite(max) || max <= 0) return 0;
  if (!Number.isFinite(current)) return 0;
  return Math.max(0, Math.min(100, (current / max) * 100));
}

function getHpColor(percent: number) {
  if (percent <= 0) {
    return "linear-gradient(90deg,#7f1d1d,#a80f0f)";
  }
  if (percent > 66) {
    return "linear-gradient(90deg,#22c55e,#16a34a)";
  }
  if (percent > 33) {
    return "linear-gradient(90deg,#f59e0b,#d97706)";
  }
  return "linear-gradient(90deg,#dc2626,#f97316)";
}

export function HpBar({ current, max, width = 160 }: HpBarProps) {
  const clampedMax = Number.isFinite(max) && max > 0 ? max : 0;
  const percent = toSafePercent(current, clampedMax);
  const value = Math.round(Number.isFinite(current) ? current : 0);
  const maxValue = Math.round(clampedMax);

  const barWidth = Math.max(80, Math.round(width));

  return (
    <div
      style={{
        minWidth: Math.min(220, barWidth),
        width: barWidth,
        color: "white",
        fontSize: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: 9,
          opacity: 0.8,
          marginBottom: 3,
          textTransform: "uppercase",
          letterSpacing: 0.45,
        }}
      >
        <span>HP</span>
        <span>{maxValue > 0 ? `${value}/${maxValue}` : `0/0`}</span>
      </div>
      <div
        style={{
          width: "100%",
          height: 3,
          borderRadius: 999,
          background: "rgba(255,255,255,0.15)",
          overflow: "hidden",
          boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.15)",
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${percent}%`,
            borderRadius: 999,
            background: getHpColor(percent),
            transition:
              "width 280ms cubic-bezier(0.16, 1, 0.3, 1), background 140ms",
          }}
        />
      </div>
    </div>
  );
}
